var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 11.5719 1 6.85786 3.92893 3.92893C6.85786 1 11.5719 1 21 1C30.4281 1 35.1421 1 38.0711 3.92893C41 6.85786 41 11.5719 41 21C41 30.4281 41 35.1421 38.0711 38.0711C35.1421 41 30.4281 41 21 41C11.5719 41 6.85786 41 3.92893 38.0711C1 35.1421 1 30.4281 1 21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 11.5719 1 6.85786 3.92893 3.92893C6.85786 1 11.5719 1 21 1C30.4281 1 35.1421 1 38.0711 3.92893C41 6.85786 41 11.5719 41 21C41 30.4281 41 35.1421 38.0711 38.0711C35.1421 41 30.4281 41 21 41C11.5719 41 6.85786 41 3.92893 38.0711C1 35.1421 1 30.4281 1 21Z",
    stroke: "#E5E7EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1083 23.3073C12.9311 24.469 13.7234 25.2753 14.6934 25.6772C18.4124 27.2178 23.5877 27.2178 27.3066 25.6772C28.2767 25.2753 29.069 24.469 28.8918 23.3073C28.7829 22.5934 28.2444 21.9989 27.8454 21.4184C27.3228 20.6488 27.2709 19.8092 27.2708 18.916C27.2708 15.4642 24.4633 12.666 21 12.666C17.5368 12.666 14.7293 15.4642 14.7293 18.916C14.7292 19.8092 14.6773 20.6488 14.1547 21.4184C13.7557 21.9989 13.2172 22.5934 13.1083 23.3073Z",
    stroke: "#2A2E34",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6666 26.834C18.0487 28.2717 19.3962 29.334 21 29.334C22.6037 29.334 23.9512 28.2717 24.3333 26.834",
    stroke: "#2A2E34",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.bffa27985595faca32d237aabcfbc33a.svg";
export { ForwardRef as ReactComponent };